export const DEPOSIT = 'deposit';
export const WITHDRAWAL = 'withdrawal';
export const SPOT = 'spot';
export const INTERNAL = 'internal';
export const REVERSAL = 'reversal';
export const GENERAL = 'general';
export const FEE_REBATE = 'fee_rebate';
export const DELIVERY = 'delivery';
export const INTERNAL_TRANSFER = 'transfer';
